import React, { createContext, FC, PropsWithChildren, useState } from 'react';

interface ContextType {
  hasError: boolean;
  setHasError: (hasError: boolean) => void;
}

export const GraphqlErrorsContext = createContext<ContextType>(null);

const GraphqlErrorsContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [hasError, setHasError] = useState<boolean>(false);

  return <GraphqlErrorsContext.Provider value={{ hasError, setHasError }}>{children}</GraphqlErrorsContext.Provider>;
};

export default GraphqlErrorsContextProvider;
